import Vue from 'vue'
import Router from 'vue-router'

const index = () => import('../components/index.vue');
const unitSearch = () => import('../components/unitSearch.vue');
const unitDetail = () => import('../components/unitDetail.vue');
const SealSearch = () => import('../components/sealSearch.vue');

Vue.use(Router)
export default new Router({
    routes: [{
        path: '/',
        component: index,
        name: 'index',
        children: [
            {
                path: '/unit_search',
                component: unitSearch,
                name: '搜索单位',
                meta: {},
            },
            {
                path: '/unit_detail',
                component: unitDetail,
                name: '单位详情',
                meta: {},
            },
            {
                path: '/seal_search/:id',
                component: SealSearch,
                name: 'sealSearch',
                meta: {},
            },
        ]
    }

    ]
})


// WEBPACK FOOTER //
// ./src/modules/search/router/index.js